module.exports = __webpack_public_path__ + "sb.svg?c8e9b05ffbde6543934005ea21851055";